import { isValidNumber } from '@/utils/isValidNumber';
import { MIN_RANGE_EXTRA_BARS, MAX_RANGE_EXTRA_BARS } from '@/enums/range-extra-bars';

export function isValidRangeExtraBars(rangeExtraBars: number | string) {
  if (!isValidNumber(rangeExtraBars, { isEmptyStringValid: true, isRequiredToBeInteger: true })) {
    return false;
  }

  if (typeof rangeExtraBars === 'string' && !rangeExtraBars.trim()) {
    return true;
  }

  const rangeExtraBarsNumber = Number(rangeExtraBars);

  return rangeExtraBarsNumber >= MIN_RANGE_EXTRA_BARS && rangeExtraBarsNumber <= MAX_RANGE_EXTRA_BARS;
}
